import { generatePath } from 'react-router';
import { useLocation } from 'react-router-dom';
import { Routes } from 'src/shared/constants/routes';
export function useEditModuleUrl(moduleId) {
    const location = useLocation();
    return {
        pathname: generatePath(Routes.ManageModule, {
            moduleId
        }),
        search: location.search
    };
}
